w2p.controller('CustomerHomeCtrl', function($scope) {
});